import { Link } from 'react-router-dom';
import { labelEnrollmentStatus } from './enrollmentLabels';
import campStyles from './Campaigns.module.css';

export type CampaignEnrollmentRow = {
  id: string;
  lead_id: string;
  step_index: number;
  status: string;
  next_send_at: string | null;
  last_sent_at: string | null;
  contact_name: string | null;
  company: string | null;
  email: string | null;
  variant_key: string | null;
  variant_label: string | null;
  clicks: number;
  last_template_name: string | null;
  sends_count: number;
};

type Props = {
  rows: CampaignEnrollmentRow[];
  loading?: boolean;
};

function fmtDt(iso: string | null): string {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('nl-NL', {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function CampaignEnrollmentsTable({ rows, loading }: Props) {
  if (loading) {
    return <p className={campStyles.panelBodyMuted}>Leads laden…</p>;
  }
  if (!rows.length) {
    return (
      <p className={campStyles.panelBodyMuted}>
        Nog geen enrollments — start de campagne of sync de lijst.
      </p>
    );
  }

  return (
    <div className={campStyles.tableWrap}>
      <table className={campStyles.dataTable}>
        <thead>
          <tr>
            <th>Lead</th>
            <th>Fase</th>
            <th>Status</th>
            <th>Variant</th>
            <th>Sends</th>
            <th>Clicks</th>
            <th>Laatste template</th>
            <th>Volgende</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>
                <Link to="/app/leads" className={campStyles.catalogLink} title={r.lead_id}>
                  {r.contact_name?.trim() || r.company?.trim() || r.email || r.lead_id.slice(0, 8)}
                </Link>
                {r.company && r.contact_name ? (
                  <div className={campStyles.mutedInline}>{r.company}</div>
                ) : null}
              </td>
              <td>
                Stap <strong>{r.step_index + 1}</strong>
              </td>
              <td>{labelEnrollmentStatus(r.status)}</td>
              <td>
                {r.variant_key ? (
                  <>
                    <strong>{r.variant_key}</strong>
                    {r.variant_label ? ` · ${r.variant_label}` : ''}
                  </>
                ) : (
                  '—'
                )}
              </td>
              <td>{r.sends_count}</td>
              <td>{r.clicks > 0 ? r.clicks : '—'}</td>
              <td className={campStyles.mutedInline}>{r.last_template_name ?? '—'}</td>
              <td className={campStyles.mutedInline}>{fmtDt(r.next_send_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
